// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.krZd46vvXsCojz {
  display: flex;
  flex-direction: column;
  padding: var(--ds-space-200, 16px);
  gap: var(--ds-space-250, 20px);
}
.k0dQBUPHjk1ekE {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.z1SaAUdeNm0g8z {
  color: var(--ds-text-subtle, #6b778c);
  font-weight: var(--ds-font-weight-medium, 500);
  text-align: center;
}
.vZM0XPCYjc26MG {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-100, 8px);
}
.QVMUF5zLBQ3U5K {
  border: 1px solid var(--ds-border, #091e4224);
}
.QVMUF5zLBQ3U5K.KkhQtwxQzzSRnC {
  border-color: var(--ds-border-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e4f0f6);
}
.QVMUF5zLBQ3U5K .Vs3QlLFQWtHU7X {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-025, 2px);
  width: 100%;
}
.QVMUF5zLBQ3U5K .Vs3QlLFQWtHU7X .LhzxQ9iotX6eiV {
  font-weight: var(--ds-font-weight-medium, 500);
}
.QVMUF5zLBQ3U5K .Vs3QlLFQWtHU7X .cWDPHNRN3YeF3d {
  color: var(--ds-text-subtle, #6b778c);
  font-size: 12px;
}
.QVMUF5zLBQ3U5K:hover {
  border: 1px solid var(--ds-border, #091e4224);
}
.QVMUF5zLBQ3U5K:hover.KkhQtwxQzzSRnC {
  border-color: var(--ds-border-selected, #0c66e4);
}
.Md0NbzpMNqwCWI {
  display: flex;
  justify-content: flex-end;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sitePickerContainer": `krZd46vvXsCojz`,
	"sitePickerHeader": `k0dQBUPHjk1ekE`,
	"noSites": `z1SaAUdeNm0g8z`,
	"siteList": `vZM0XPCYjc26MG`,
	"siteItem": `QVMUF5zLBQ3U5K`,
	"selected": `KkhQtwxQzzSRnC`,
	"siteInfo": `Vs3QlLFQWtHU7X`,
	"siteName": `LhzxQ9iotX6eiV`,
	"siteUrl": `cWDPHNRN3YeF3d`,
	"sitePickerActions": `Md0NbzpMNqwCWI`
};
export default ___CSS_LOADER_EXPORT___;
